import { useEffect, useState } from 'react';
import { globalBus } from '../streams/wsBus';

type Flags = { ENABLE_LEGACY: boolean; STREAM_DEBUG: boolean };

export function SettingsPanel() {
  const [flags, setFlags] = useState<Flags>({ ENABLE_LEGACY: true, STREAM_DEBUG: false });
  const [profile, setProfile] = useState<{ env: string; user?: string; scopes: string[] }>({ env: 'dev', user: 'Operator', scopes: ['scene:read'] });
  const [theme, setTheme] = useState('system');

  useEffect(() => {
    const unsub = globalBus.subscribe((message) => {
      if (message.t === 'scene' && message.id === 'hivecore.settings') {
        const flagsWidget = message.body?.widgets?.find((w: any) => w.key === 'settings.flags');
        if (flagsWidget?.values) setFlags(flagsWidget.values);
        const profileWidget = message.body?.widgets?.find((w: any) => w.key === 'settings.profile');
        if (profileWidget?.values) setProfile(profileWidget.values);
        const themeWidget = message.body?.widgets?.find((w: any) => w.key === 'settings.theme');
        if (themeWidget?.value) setTheme(themeWidget.value);
      }
    });
    globalBus.sendIntent('scene.request', { id: 'hivecore.settings' });
    return unsub;
  }, []);

  const toggleFlag = (name: keyof Flags) => {
    const next = { ...flags, [name]: !flags[name] };
    setFlags(next);
    globalBus.sendIntent('settings.updateFlags', { flags: next });
  };

  const updateTheme = (next: string) => {
    setTheme(next);
    globalBus.sendIntent('settings.updateTheme', { theme: next });
  };

  return (
    <div className="panel">
      <header className="panel-header">
        <h2>Settings</h2>
      </header>
      <section className="settings-section">
        <h3>Profile</h3>
        <p><strong>Environment:</strong> {profile.env}</p>
        {profile.user && <p><strong>User:</strong> {profile.user}</p>}
        <p><strong>Scopes:</strong> {profile.scopes.join(', ')}</p>
      </section>
      <section className="settings-section">
        <h3>Feature Flags</h3>
        <label>
          <input type="checkbox" checked={flags.ENABLE_LEGACY} onChange={() => toggleFlag('ENABLE_LEGACY')} />
          Enable Legacy UI
        </label>
        <label>
          <input type="checkbox" checked={flags.STREAM_DEBUG} onChange={() => toggleFlag('STREAM_DEBUG')} />
          Stream debug logs
        </label>
      </section>
      <section className="settings-section">
        <h3>Theme</h3>
        <select value={theme} onChange={(e) => updateTheme(e.target.value)}>
          <option value="system">System</option>
          <option value="light">Light</option>
          <option value="dark">Dark</option>
        </select>
      </section>
    </div>
  );
}
